import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Stack } from '@mui/material';
import PurchaseApproveTable from './PurchaseApproveTable';

const PurchaseApprove = () => {
  const [isChanged, setIsChanged] = useState(false);

  return (
    <Container>
      <Stack direction="column" justifyContent="flex-start" width="100%" my={2}>
        <PurchaseApproveTable
          isChanged={isChanged}
          setIsChanged={setIsChanged}
          defaultStatus="2,3"
          hideStatusFilter={true}
          pageTitle="Purchase Approve"
        />
      </Stack>
    </Container>
  );
};

export default PurchaseApprove;
